const ICON_ROOT = "/images/icon";

export const Images = {
  icons: {
    common: {
      close: `${ICON_ROOT}/common/close_icon.svg`,
      crossReset: `${ICON_ROOT}/common/cross_reset_icon.svg`,
      display: `${ICON_ROOT}/common/display_icon.svg`,
      external: `${ICON_ROOT}/common/external_icon.svg`,
      help: `${ICON_ROOT}/common/help_icon.svg`,
      hide: `${ICON_ROOT}/common/hide_icon.svg`,
    },
    masters: {
      circleCloseIcon: `${ICON_ROOT}/masters/circle_close_icon.svg`,
      plateNoIcon: `${ICON_ROOT}/masters/plate_no_icon.svg`,
      srideIcon: `${ICON_ROOT}/masters/sride_icon.svg`,
      didiIcon: `${ICON_ROOT}/masters/didi_icon.svg`,
      uberIcon: `${ICON_ROOT}/masters/uber_icon.svg`,
    },
    orderDetail: {
      mapPin: `${ICON_ROOT}/order-detail/map_pin_icon.svg`,
      memo: `${ICON_ROOT}/order-detail/memo_icon.svg`,
      messageHistory: `${ICON_ROOT}/order-detail/message_history_icon.svg`,
      place: `${ICON_ROOT}/order-detail/place_icon.svg`,
      marker: {
        actualDeparture: `${ICON_ROOT}/order-detail/marker/actual_departure_icon.svg`,
        actualDestination: `${ICON_ROOT}/order-detail/marker/actual_destination_icon.svg`,
        arrival: `${ICON_ROOT}/order-detail/marker/arrival_icon.svg`,
        carTrack: `${ICON_ROOT}/order-detail/marker/car_track_icon_red.svg`,
        carTrackIcon: {
          green: `${ICON_ROOT}/order-detail/marker/car-track-icon/car_track_icon_green.svg`,
          red: `${ICON_ROOT}/order-detail/marker/car-track-icon/car_track_icon_red.svg`,
          blue: `${ICON_ROOT}/order-detail/marker/car-track-icon/car_track_icon_blue.svg`,
          purple: `${ICON_ROOT}/order-detail/marker/car-track-icon/car_track_icon_purple.svg`,
          black: `${ICON_ROOT}/order-detail/marker/car-track-icon/car_track_icon_black.svg`,
        },
        carTrackSelectedIcon: {
          green: `${ICON_ROOT}/order-detail/marker/car-track-icon/car_track_selected_icon_green.svg`,
          red: `${ICON_ROOT}/order-detail/marker/car-track-icon/car_track_selected_icon_red.svg`,
          blue: `${ICON_ROOT}/order-detail/marker/car-track-icon/car_track_selected_icon_blue.svg`,
          purple: `${ICON_ROOT}/order-detail/marker/car-track-icon/car_track_selected_icon_purple.svg`,
          black: `${ICON_ROOT}/order-detail/marker/car-track-icon/car_track_selected_icon_black.svg`,
        },
        departure: `${ICON_ROOT}/order-detail/marker/departure_icon.svg`,
        destination: `${ICON_ROOT}/order-detail/marker/destination_icon.svg`,
      },
    },
    sideMenu: {
      account: `${ICON_ROOT}/side-menu/account_icon.svg`,
      accountMenu: `${ICON_ROOT}/side-menu/account_menu_icon.svg`,
      accounts: `${ICON_ROOT}/side-menu/accounts_icon.svg`,
      masters: `${ICON_ROOT}/side-menu/masters_icon.svg`,
      arrowLeft: `${ICON_ROOT}/side-menu/arrow_left_icon.svg`,
      arrowRight: `${ICON_ROOT}/side-menu/arrow_right_icon.svg`,
      carLocation: `${ICON_ROOT}/side-menu/car_location.svg`,
      news: `${ICON_ROOT}/side-menu/news_icon.svg`,
      openFilter: `${ICON_ROOT}/side-menu/open_filter_icon.svg`,
      orders: `${ICON_ROOT}/side-menu/orders_icon.svg`,
      passwordChange: `${ICON_ROOT}/side-menu/password_change_icon.svg`,
      signout: `${ICON_ROOT}/side-menu/signout_icon.svg`,
      internal: `${ICON_ROOT}/side-menu/internal_icon.svg`,
      settlements: `${ICON_ROOT}/side-menu/internal_icon.svg`,
    },
  },
};
